function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import remoteFileObjToLocal from '@uppy/utils/lib/remoteFileObjToLocal';

var SharedHandler = /*#__PURE__*/function () {
  function SharedHandler(plugin) {
    _classCallCheck(this, SharedHandler);

    this.plugin = plugin;
    this.filterItems = this.filterItems.bind(this);
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
    this.recordShiftKeyPress = this.recordShiftKeyPress.bind(this);
    this.isChecked = this.isChecked.bind(this);
    this.loaderWrapper = this.loaderWrapper.bind(this);
  }

  _createClass(SharedHandler, [{
    key: "filterItems",
    value: function filterItems(items) {
      var state = this.plugin.getPluginState();

      if (!state.filterInput || state.filterInput === '') {
        return items;
      }

      return items.filter(function (folder) {
        return folder.name.toLowerCase().indexOf(state.filterInput.toLowerCase()) !== -1;
      });
    }
  }, {
    key: "recordShiftKeyPress",
    value: function recordShiftKeyPress(e) {
      this.isShiftKeyPressed = e.shiftKey;
    }
    /**
     * Toggles file/folder checkbox to on/off state while updating files list.
     *
     * Note that some extra complexity comes from supporting shift+click to
     * toggle multiple checkboxes at once, which is done by getting all files
     * in between last checked file and current one.
     */

  }, {
    key: "toggleCheckbox",
    value: function toggleCheckbox(e, file) {
      e.stopPropagation();
      e.preventDefault();
      e.currentTarget.focus();

      var _this$plugin$getPlugi = this.plugin.getPluginState(),
          folders = _this$plugin$getPlugi.folders,
          files = _this$plugin$getPlugi.files;

      var items = this.filterItems(folders.concat(files)); // Shift-clicking selects a single consecutive list of items
      // starting at the previous click and deselects everything else.

      if (this.lastCheckbox && this.isShiftKeyPressed) {
        var prevIndex = items.indexOf(this.lastCheckbox);
        var currentIndex = items.indexOf(file);

        var _currentSelection = prevIndex < currentIndex ? items.slice(prevIndex, currentIndex + 1) : items.slice(currentIndex, prevIndex + 1);

        var reducedCurrentSelection = []; // Check restrictions on each file in currentSelection,
        // reduce it to only contain files that pass restrictions

        var _iterator = _createForOfIteratorHelper(_currentSelection),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            var uppy = this.plugin.uppy;
            var restrictionError = uppy.validateRestrictions(remoteFileObjToLocal(item), [].concat(_toConsumableArray(uppy.getFiles()), reducedCurrentSelection));

            if (!restrictionError) {
              reducedCurrentSelection.push(item);
            } else {
              uppy.info({
                message: restrictionError.message
              }, 'error', uppy.opts.infoTimeout);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        this.plugin.setPluginState({
          currentSelection: reducedCurrentSelection
        });
        return;
      }

      this.lastCheckbox = file;

      var _this$plugin$getPlugi2 = this.plugin.getPluginState(),
          currentSelection = _this$plugin$getPlugi2.currentSelection;

      if (this.isChecked(file)) {
        this.plugin.setPluginState({
          currentSelection: currentSelection.filter(function (item) {
            return item.id !== file.id;
          })
        });
      } else {
        this.plugin.setPluginState({
          currentSelection: currentSelection.concat([file])
        });
      }
    }
  }, {
    key: "isChecked",
    value: function isChecked(file) {
      var _this$plugin$getPlugi3 = this.plugin.getPluginState(),
          currentSelection = _this$plugin$getPlugi3.currentSelection; // comparing id instead of the file object, because the reference to the object
      // changes when we switch folders, and the file list is updated


      return currentSelection.some(function (item) {
        return item.id === file.id;
      });
    }
  }, {
    key: "loaderWrapper",
    value: function loaderWrapper(promise, then, catch_) {
      var _this = this;

      promise.then(function (result) {
        _this.plugin.setPluginState({
          loading: false
        });

        then(result);
      }).catch(function (err) {
        _this.plugin.setPluginState({
          loading: false
        });

        catch_(err);
      });
      this.plugin.setPluginState({
        loading: true
      });
    }
  }]);

  return SharedHandler;
}();

export { SharedHandler as default };